import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]" data-testid="auth-loading">
        <img
          src="/vv_logo.jpg"
          alt="Vintage Vantage"
          className="h-16 w-16 rounded-full object-cover ring-1 ring-[#E5E0D6] animate-pulse"
        />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
